import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

// Wallets

export const getWalletsStatuses = createAsyncThunk(
    'financeWallets/getWalletsStatuses',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/getStatuses?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return response.data.data;
        } else {
            return rejectWithValue('Failed to get wallets statuses');
        }
        } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
        return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const searchWallets = createAsyncThunk(
    'financeWallets/searchWallets',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/search?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return response.data.data;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
        return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const uploadWallets = createAsyncThunk(
    'financeWallets/uploadWallets',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/importingWallets?XDEBUG_SESSION_START=MyVSCode';

        let formData = new FormData();

        if (data.walletsFile) { 
            formData.append('walletsFile', data.walletsFile); 
        }
            formData.append('data', JSON.stringify(data));

        try {
            const response = await apiInstance.post(api, formData);

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to upload wallets');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const createWallet = createAsyncThunk(
    'financeWallets/createWallet',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/create?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));
        
        if (response.data.result) {
            return response.data.data;
        } else {
            return rejectWithValue('Failed to create wallet');
        }
        } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
        return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const updateWallet = createAsyncThunk(
    'financeWallets/updateWallet',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/update?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return response.data.data;
        } else {
            return rejectWithValue('Failed to update wallet');
        }
        } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
        return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

// Transactions

export const searchTransactions = createAsyncThunk(
    'financeWallets/searchTransactions',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/getTransactionsWallet?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));
        
        if (response.data.result) {
            return response.data.data;
        } else {
            return rejectWithValue('Failed to search transactions');
        }
        } catch (error) {
        console.error('Ошибка при выполнении запроса:', error);
        return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const createTransaction = createAsyncThunk(
    'financeWallets/createTransaction',
    async (data, { rejectWithValue }) => {
        const api = '/wallets/addTransaction?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to create transaction');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

// Promocodes

export const searchPromocodes = createAsyncThunk(
    'financeWallets/searchPromocodes',
    async (data, { rejectWithValue }) => {
        const api = '/promocodes/search?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to search promocodes');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const createPromocode = createAsyncThunk(
    'financeWallets/createPromocode',
    async (data, { rejectWithValue }) => {
        const api = '/promocodes/create?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to create promocode');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const updatePromocode = createAsyncThunk(
    'financeWallets/updatePromocode',
    async (data, { rejectWithValue }) => {
        const api = '/promocodes/update?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to update promocode');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const deletePromocode = createAsyncThunk(
    'financeWallets/deletePromocode',
    async (data, { rejectWithValue }) => {
        const api = '/promocodes/delete?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to delete promocode');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getWalletsStatusesStatus: null,
    searchWalletsStatus: null,
    uploadWalletsStatus: null,
    createWalletStatus: null,
    updateWalletStatus: null,
    getWalletTransactionsStatus: null,
    createTransactionStatus: null,

    // Promocodes statuses
    searchPromocodesStatus: null,
    createPromocodeStatus: null,
    updatePromocodeStatus: null,
    deletePromocodeStatus: null,

    walletsStatuses: [],

    wallets: [],
    totalWallets: 0,
    currentWalletPage: 1,
    currentWalletId: null,
    selectedWallet: null,

    walletTransactions: null,
    totalWalletTransactions: 0,
    
    uploadData: null,

    // Promocodes data
    promocodes: [],
    totalPromocodes: 0,
    currentPromocodesPage: 1,

    // UI states
    createModalVisible: false,
    createPromocodeModalVisible: false,
    drawerVisible: false,
    promocodeDrawerVisible: false,
    selectedPromocode: null,
};

const financeWalletsSlice = createSlice({
    name: 'financeWallets',
    initialState,
    extraReducers: (builder) => {
        builder
        // getWalletsStatuses
        .addCase(getWalletsStatuses.pending, (state) => { state.getWalletsStatusesStatus = 'pending'; })
        .addCase(getWalletsStatuses.fulfilled, (state, action) => { state.getWalletsStatusesStatus = 'fulfilled'; state.walletsStatuses = action.payload.statuses; })
        .addCase(getWalletsStatuses.rejected, (state) => { state.getWalletsStatusesStatus = 'rejected'; })

        // searchWallets
        .addCase(searchWallets.pending, (state) => { state.searchWalletsStatus = 'pending'; })
        .addCase(searchWallets.fulfilled, (state, action) => { state.searchWalletsStatus = 'fulfilled'; state.wallets = action.payload.wallets; state.totalWallets = action.payload.countWallets; })
        .addCase(searchWallets.rejected, (state) => { state.searchWalletsStatus = 'rejected'; })

        // uploadWallets
        .addCase(uploadWallets.pending, (state) => { state.uploadWalletsStatus = 'pending'; })
        .addCase(uploadWallets.fulfilled, (state, action) => { state.uploadWalletsStatus = 'fulfilled'; state.uploadData = action.payload; })
        .addCase(uploadWallets.rejected, (state) => { state.uploadWalletsStatus = 'rejected'; })

        // createWallet
        .addCase(createWallet.pending, (state) => { state.createWalletStatus = 'pending'; })
        .addCase(createWallet.fulfilled, (state, action) => { 
            state.createWalletStatus = 'fulfilled'; 
            state.createModalVisible = false; // Закрываем модалку после успешного создания
            state.currentWalletId = action.payload.wallet?.id || null; // Сохраняем ID созданного кошелька
        })
        .addCase(createWallet.rejected, (state) => { state.createWalletStatus = 'rejected'; })

        // updateWallet
        .addCase(updateWallet.pending, (state) => { state.updateWalletStatus = 'pending'; })
        .addCase(updateWallet.fulfilled, (state) => { state.updateWalletStatus = 'fulfilled'; })
        .addCase(updateWallet.rejected, (state) => { state.updateWalletStatus = 'rejected'; })

        // searchTransactions
        .addCase(searchTransactions.pending, (state) => { state.getWalletTransactionsStatus = 'pending'; })
        .addCase(searchTransactions.fulfilled, (state, action) => { state.getWalletTransactionsStatus = 'fulfilled'; state.walletTransactions = action.payload.walletTransactions; state.totalWalletTransactions = action.payload.countWalletTransactions; })
        .addCase(searchTransactions.rejected, (state) => { state.getWalletTransactionsStatus = 'rejected'; })

        // createTransaction
        .addCase(createTransaction.pending, (state) => { state.createTransactionStatus = 'pending'; })
        .addCase(createTransaction.fulfilled, (state) => { state.createTransactionStatus = 'fulfilled'; })
        .addCase(createTransaction.rejected, (state) => { state.createTransactionStatus = 'rejected'; })

        // searchPromocodes
        .addCase(searchPromocodes.pending, (state) => { state.searchPromocodesStatus = 'pending'; })
        .addCase(searchPromocodes.fulfilled, (state, action) => { state.searchPromocodesStatus = 'fulfilled'; state.promocodes = action.payload.promocodes; state.totalPromocodes = action.payload.countPromocodes; })
        .addCase(searchPromocodes.rejected, (state) => { state.searchPromocodesStatus = 'rejected'; })

        // createPromocode
        .addCase(createPromocode.pending, (state) => { state.createPromocodeStatus = 'pending'; })
        .addCase(createPromocode.fulfilled, (state) => { 
            state.createPromocodeStatus = 'fulfilled'; 
            state.createPromocodeModalVisible = false; // Закрываем модалку после успешного создания
        })
        .addCase(createPromocode.rejected, (state) => { state.createPromocodeStatus = 'rejected'; })

        // updatePromocode
        .addCase(updatePromocode.pending, (state) => { state.updatePromocodeStatus = 'pending'; })
        .addCase(updatePromocode.fulfilled, (state) => { state.updatePromocodeStatus = 'fulfilled'; })
        .addCase(updatePromocode.rejected, (state) => { state.updatePromocodeStatus = 'rejected'; })

        // deletePromocode
        .addCase(deletePromocode.pending, (state) => { state.deletePromocodeStatus = 'pending'; })
        .addCase(deletePromocode.fulfilled, (state) => { state.deletePromocodeStatus = 'fulfilled'; })
        .addCase(deletePromocode.rejected, (state) => { state.deletePromocodeStatus = 'rejected'; })

        .addCase(PURGE, () => { return initialState; });
    },
    reducers: {
        setCurrentWalletPage(state, action) { state.currentWalletPage = action.payload; },
        setCurrentPromocodesPage(state, action) { state.currentPromocodesPage = action.payload; },
        
        // UI actions
        setSelectedWallet(state, action) { state.selectedWallet = action.payload; },
        setDrawerVisible(state, action) { state.drawerVisible = action.payload; },
        setCreateModalVisible(state, action) { state.createModalVisible = action.payload; },
        
        openWalletDrawer(state, action) {
            state.selectedWallet = action.payload;
            state.drawerVisible = true;
        },
        closeWalletDrawer(state) {
            state.selectedWallet = null;
            state.drawerVisible = false;
        },
        
        openCreateModal(state) {
            state.createModalVisible = true;
        },
        closeCreateModal(state) {
            state.createModalVisible = false;
        },
        
        openCreatePromocodeModal(state) {
            state.createPromocodeModalVisible = true;
        },
        closeCreatePromocodeModal(state) {
            state.createPromocodeModalVisible = false;
        },
        
        openPromocodeDrawer(state, action) {
            state.selectedPromocode = action.payload;
            state.promocodeDrawerVisible = true;
        },
        closePromocodeDrawer(state) {
            state.selectedPromocode = null;
            state.promocodeDrawerVisible = false;
        },
        
        setCurrentWalletId(state, action) {
            state.currentWalletId = action.payload;
        },
        clearCurrentWalletId(state) {
            state.currentWalletId = null;
        },
        clearUploadData: (state) => {
            state.uploadData = null;
        },
    },
});

export const {
    setCurrentWalletPage,
    setCurrentPromocodesPage,
    setSelectedWallet,
    setDrawerVisible,
    setCreateModalVisible,
    openWalletDrawer,
    closeWalletDrawer,
    openCreateModal,
    closeCreateModal,
    openCreatePromocodeModal,
    closeCreatePromocodeModal,
    openPromocodeDrawer,
    closePromocodeDrawer,
    setCurrentWalletId,
    clearCurrentWalletId,
    clearUploadData,
} = financeWalletsSlice.actions;

export default financeWalletsSlice.reducer;
